import React from "react";

// components
import GettingStartedProgress from "./GettingStartedProgress";

// assets
import styles from "@/assets/styles/containers/getting-started/getting-started-preview.module.scss";


interface IGettingStartedPreview {
  percentage: number;
  progress: number;
}

function GettingStartedPreview({ percentage, progress }: IGettingStartedPreview) {

  return (
    <div className={styles["locl-getting-started-preview"]}>
      <h3 className={styles["locl-getting-started-preview__header"]}>
        <span className={styles["locl-getting-started-preview__header_title"]}>
          Getting started:
        </span>
        <span className={styles["locl-getting-started-preview__header_hint"]}>
          you've completed <span className={styles["locl-getting-started-preview__header_percent"]}>{percentage}%</span> of your lo:live journey
        </span>
      </h3>
      <GettingStartedProgress progress={progress} percentage={percentage}/>
    </div>
  );
}

export default GettingStartedPreview;
